import { IFirstHandReport } from 'api/home/types';
import Link from 'next/link';
import { ImageComponent } from 'components/common/ImageComponent';
import { IResortPathInfo } from 'api/resort/types';
import { Routes } from 'routes';
import { formatAgoTimestampOrString } from 'util/formatAgo';
import styles from './styles.module.scss';

export const FirstHandReportItem = ({
  title, largeImage, translated, date, resortPathInfo,
}: IFirstHandReport & { resortPathInfo?: IResortPathInfo }) => {
  const href = resortPathInfo
    ? Routes.resortSnowReport(resortPathInfo)
    : '#';

  return (
    <Link href={href} className={styles.link}>
      <div className={styles.box}>
        <figure>
          <ImageComponent
            alt={title}
            src={largeImage}
            className={styles.image}
          />
        </figure>
        <div className={styles.footer}>
          <span className={styles.title}>{title}</span>
          <p className={styles.description}><i>{translated}</i></p>
          <p className={styles.updatedAt}>{formatAgoTimestampOrString(date)}</p>
        </div>
      </div>
    </Link>
  );
};
